<aipb-ol-map
  (mapClick)="onMapClick($event)"
  (mapMoveEnd)="onMapMoveEnd()"
  (mapReady)="onMapReady($event)"
  [controls]="controls$ | async"
  [interactions]="interactions$ | async"
  [layers]="layers$ | async"
  [view]="view$ | async"
></aipb-ol-map>
